import React from "react";
import "./style.css";

const SLATable = () => {
  return (
    
      <div className="table-responsive">
        <table className="table table-responsive-md table-bordered sla-table overflow-auto">
          <thead>
            <tr className="header-row">
              <th scope="col" className="header-background"></th>
              <th scope="col" className="header-background"></th>
              <th scope="col" className="text-center p-2 header-background">
                Basic
              </th>
              <th scope="col" className="text-center p-2 header-background">
                Enterprise
              </th>
              <th scope="col" className="text-center header-background header-min-width">
                Enterprise Plus
              </th>
              <th scope="col" className="text-center p-2 header-background">
                Strategic
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="content-row">
              <td rowSpan="3"  className="align-middle fw-bold category-header ">
                Service Coverage
              </td>
              <td className="feature-description">
                <span className="fs-3">
                  {" "}
                  8/5 weekdays per chosen business hours
                </span>
                <sup>*</sup>
              </td>
              <td className="checkmark ">
                ✓<span className="px-4"></span>
              </td>
              <td ></td>
              <td ></td>
              <td ></td>
            </tr>

            <tr className="content-row">
              <td className="fs-3">24/7 Global</td>
              <td ></td>
              <td className=" checkmark">
                ✓ <span className="px-4"></span>
              </td>
              <td className="checkmark">✓</td>
              <td className="checkmark">✓</td>
            </tr>

            <tr className="content-row"></tr>
            <tr className="content-row">
              <td rowSpan="3" className="align-middle fw-bold category-header">
                Time To First Response
              </td>
              <td className="feature-description">
                <span className="fs-3"> P1 (Critical)</span>
              </td>
              <td>2 hrs</td>
              <td>1 hr</td>
              <td>30 min</td>
              <td>20 mins </td>
            </tr>

            <tr className="content-row">
              <td className="feature-description">
                <span className="fs-3">P2 (Major)</span>
              </td>
              <td>8 hrs</td>
              <td>4 hrs</td>
              <td>4 hrs</td>
              <td>2 hrs</td>
            </tr>
            <tr className="content-row">
              <td className="feature-description">
                <span className="fs-3"> P3 (Minor)</span>
              </td>
              <td>24 hrs</td>
              <td>12 hrs </td>
              <td>8 hrs</td>
              <td>8 hrs</td>
            </tr>
          </tbody>
        </table>
      </div>

  );
};

export default SLATable;
